import { Requester } from "./Setup/Requester";
import { Approver } from "./Process/Approver";
import { AccessRequired } from "../../../common/AccessRequired";

function EmployeeRequest({ user, userAccess, isHideSideMenu }) {
  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="EmployeesTabInfo shadow-xl">
            <div className="employeesTab-header">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Personnel >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Employee Request"}</span>
              </div>
              <div className='row' style={{ justifyContent: "space-between", alignItems: "center" }}>
                <h3>Employee Request</h3>
              </div>
            </div>

            <div className='p-4 space-y-4'>
              {/* Conditional Rendering based on provided access keys */}
              {userAccess?.isEmployeeRequestRequester === true && (
                <Requester user={user} />
              )}

              {userAccess?.isEmployeeRequestApprover === true && (
                <Approver user={user} />
              )}

              {!userAccess?.isEmployeeRequestApprover && !userAccess?.isEmployeeRequestRequester && (
                <div className="flex justify-center mt-8">
                  <div className="w-full max-w-2xl">
                    <AccessRequired userAccess={userAccess} moduleName={"Employee Request Access"} pathName={"/employeeRequestAccess"} />
                  </div>
                </div>

              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeRequest;